import SelectBox from 'devextreme-react/select-box';
import type { TimeOffOrgOptions } from '../../../../api/timeOff';

export type TimeOffCalendarOrgFilter =
  | { kind: 'all' }
  | { kind: 'company'; value: string }
  | { kind: 'department'; value: string };

interface TimeOffCalendarOrgFilterProps {
  options: TimeOffOrgOptions;
  value: TimeOffCalendarOrgFilter;
  onChange: (value: TimeOffCalendarOrgFilter) => void;
  loading?: boolean;
  compact?: boolean;
}

const ALL_VALUE = '__all__';

export function TimeOffCalendarOrgFilter({
  options,
  value,
  onChange,
  loading,
  compact = false
}: TimeOffCalendarOrgFilterProps) {
  const companyValue = value.kind === 'company' ? value.value : ALL_VALUE;
  const departmentValue = value.kind === 'department' ? value.value : ALL_VALUE;
  const width = compact ? 160 : '100%';

  const selectProps = compact
    ? { stylingMode: 'outlined' as const, placeholder: '' }
    : { stylingMode: 'outlined' as const, labelMode: 'floating' as const, placeholder: '' };

  return (
    <>
      <SelectBox
        {...selectProps}
        className="time-off-calendar-filter__input"
        label={compact ? undefined : 'Company'}
        disabled={loading}
        width={width}
        items={[ALL_VALUE, ...options.companies]}
        displayExpr={(item: string) => (item === ALL_VALUE ? 'All companies' : item)}
        value={companyValue}
        searchEnabled={options.companies.length > 8}
        placeholder={compact ? 'Company' : undefined}
        onValueChanged={(e) => {
          const next = e.value as string | null | undefined;
          if (!next || next === ALL_VALUE) {
            onChange({ kind: 'all' });
            return;
          }
          onChange({ kind: 'company', value: next });
        }}
      />
      <SelectBox
        {...selectProps}
        className="time-off-calendar-filter__input"
        label={compact ? undefined : 'Department'}
        disabled={loading}
        width={width}
        items={[ALL_VALUE, ...options.departments]}
        displayExpr={(item: string) => (item === ALL_VALUE ? 'All departments' : item)}
        value={departmentValue}
        searchEnabled={options.departments.length > 8}
        placeholder={compact ? 'Department' : undefined}
        onValueChanged={(e) => {
          const next = e.value as string | null | undefined;
          if (!next || next === ALL_VALUE) {
            onChange({ kind: 'all' });
            return;
          }
          onChange({ kind: 'department', value: next });
        }}
      />
    </>
  );
}
